var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showedItems && _vm.showedItems.length)?_c('div',{staticClass:"projects grid-x grid-margin-x align-top"},_vm._l((_vm.showedItems),function(item,key){return _c('work',{key:key,attrs:{"data-cat":item.type,"work":item}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }